import { Permission } from "./permission.model";

export enum RoleName {
  SUPER_ADMIN = 'Super Admin',
  ENTITY_ADMIN = 'Entity Admin',
  CLINIC_ADMIN = 'Clinic Admin',
  STANDARD_USER = 'Standard User'
}
export type RoleScope = 'Global' | 'Clinic';

export interface Role {
  id: string;
  name: RoleName;
  description: string;
  scope: RoleScope;
}
// NOTE: IDs below are placeholder values — they do not match backend UUIDs.
// Permission checks use role names (not IDs), so this array is not used for access control.
// Replace with real backend IDs if this array is ever used for display/lookup, or remove if unused.
export const ROLES: Role[] = [
  {
    id: 'role-1',
    name: RoleName.SUPER_ADMIN,
    description: 'BlueDop employee with global system access',
    scope: 'Global'
  },
  {
    id: 'role-2',
    name: RoleName.ENTITY_ADMIN,
    description: 'Administrative user within a Clinic',
    scope: 'Clinic'
  },
  {
    id: 'role-3',
    name: RoleName.STANDARD_USER,
    description: 'Basic operational user',
    scope: 'Clinic'
  }
];
export const ROLE_PERMISSIONS: Record<RoleName, Permission[]> = {

  [RoleName.SUPER_ADMIN]: [
    'MANAGE_ENTITIES',
    'MANAGE_CLINICS',
    'UPDATE_CLINICS',
    'MANAGE_PATIENTS',
    'MANAGE_USERS',
    'RESET_PASSWORD',
    'UNLOCK_ACCOUNT',
    'VIEW_PATIENTS'
  ],

  [RoleName.ENTITY_ADMIN]: [
    'MANAGE_CLINICS',
    'UPDATE_CLINICS',
    'MANAGE_PATIENTS',
    'MANAGE_USERS',
    'RESET_PASSWORD',
    'UNLOCK_ACCOUNT',
    'VIEW_PATIENTS'
  ],

  [RoleName.CLINIC_ADMIN]: [
    'UPDATE_CLINICS',
    'MANAGE_PATIENTS',
    'MANAGE_USERS',
    'RESET_PASSWORD',
    'UNLOCK_ACCOUNT',
    'VIEW_PATIENTS'
  ],

  [RoleName.STANDARD_USER]: [
    'MANAGE_PATIENTS',
    'MANAGE_USERS',
    'VIEW_PATIENTS'
  ]

};
